import React, { memo, useCallback } from 'react';

import { ThreeDStockMaterialsCompactListItemMaterial } from './ThreeDStockMaterialsCompactListItem.types';
import {
  MaterialBrandID,
  MaterialNanoID,
  UpdateMaterialCacheAction
} from '../../../../materials/materialsTypes';
import { OnLightboxOpenAction } from '../../../../../helpers/LightboxWrapper';

import { ThreeDStockMaterialsCompactListItemPreview } from './components/ThreeDStockMaterialsCompactListItemPreview';
import { ThreeDStockMaterialsCompactListItemInfo } from './components/ThreeDStockMaterialsCompactListItemInfo';
import { ThreeDStockMaterialsCompactListItemButtons } from './components/ThreeDStockMaterialsCompactListItemButtons';

type ThreeDStockMaterialsCompactListItemProps = {
  material: ThreeDStockMaterialsCompactListItemMaterial;
  onMaterialEditButtonMouseEnter?: (materialNanoId: MaterialNanoID) => void;
  onLightboxOpen: OnLightboxOpenAction;
  onMaterialBrandButtonClick: (brandId: MaterialBrandID) => void;
  updateMaterialCache?: UpdateMaterialCacheAction<ThreeDStockMaterialsCompactListItemMaterial>;
};

function ThreeDStockMaterialsCompactListItem({
  material,
  onMaterialEditButtonMouseEnter,
  onLightboxOpen,
  onMaterialBrandButtonClick,
  updateMaterialCache
}: ThreeDStockMaterialsCompactListItemProps) {
  const handleOpenLightbox = useCallback(() => {
    if (material.image) {
      onLightboxOpen(material);
    }
  }, [material, onLightboxOpen]);

  const handleEditButtonMouseEnter = useCallback<() => void>(() => {
    onMaterialEditButtonMouseEnter(material.nanoId);
  }, [onMaterialEditButtonMouseEnter, material.nanoId]);

  return (
    <div className="group rounded-xl relative has-[:checked]:ring has-[:checked]:bg-blue-500/20 has-[:checked]:hover:bg-blue-500/20 dark:has-[:checked]:hover:bg-blue-500/20 hover:bg-gray-100 dark:hover:bg-gray-850 flex gap-4 items-center p-2 max-w-full transition-colors duration-150 ease-out">
      <ThreeDStockMaterialsCompactListItemPreview
        material={material}
        onLightboxOpen={handleOpenLightbox}
      />

      <ThreeDStockMaterialsCompactListItemInfo
        material={material}
        onMaterialBrandButtonClick={onMaterialBrandButtonClick}
      />

      <ThreeDStockMaterialsCompactListItemButtons
        material={material}
        updateMaterialCache={updateMaterialCache}
        onEditButtonMouseEnter={handleEditButtonMouseEnter}
      />
    </div>
  );
}

export default memo<ThreeDStockMaterialsCompactListItemProps>(
  ThreeDStockMaterialsCompactListItem
);
